<template>
  <el-dialog :visible="visible" :title="isEdit ? '編輯地址': '新增地址'" destroy-on-close @close="$emit('onClose')">
    <el-form ref="form" :model="formData" label-width="100px" :rules="rules" :label-position="isMobile ? 'top': ''">
      <el-form-item label="國家">
        <el-radio v-model="formData.province" label="台灣">台灣</el-radio>
        <span style="margin-right: 30px;">or</span>
        <el-input v-model="formData.province" style="width: 60%" />
      </el-form-item>
      <el-form-item label="縣市" prop="city">
        <el-select v-if="isTaiwan" v-model="formData.city" placeholder="請選擇縣市">
          <el-option v-for="city in cities" :key="city" :label="city" :value="city" />
        </el-select>
        <el-input v-else v-model="formData.city" />
      </el-form-item>
      <el-form-item label="區域" prop="district">
        <el-select v-if="isTaiwan" v-model="formData.district" placeholder="請選擇國家">
          <el-option v-for="district in districts" :key="district.name" :label="district.name" :value="district.name" />
        </el-select>
        <el-input v-else v-model="formData.district" />
      </el-form-item>
      <el-form-item label="郵遞區號">
        <el-input v-model="formData.postCode" />
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="formData.address" />
      </el-form-item>
      <el-form-item label="收件人姓名" prop="receiverName">
        <el-input v-model="formData.receiverName" />
      </el-form-item>
      <el-form-item label="收件人電話" prop="receiverTel">
        <el-input v-model="formData.receiverTel" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="$emit('onClose')">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import TaiwanCityMap from '@/assets/taiwan'
import { mapGetters } from 'vuex'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    dataSource: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      TaiwanCityMap,
      formData: {
        province: '台灣',
        city: '',
        district: '',
        postCode: '',
        address: '',
        receiverName: '',
        receiverTel: ''
      },
      rules: {
        city: [
          { required: true, message: '請填寫縣市', trigger: 'change' }
        ],
        district: [
          { required: true, message: '請填寫區域', trigger: 'change' }
        ],
        address: [
          { required: true, message: '請填寫地址', trigger: 'change' }
        ],
        receiverName: [
          { required: true, message: '請填寫收件人姓名', trigger: 'change' }
        ],
        receiverTel: [
          { required: true, message: '請填寫收件人電話', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
    isTaiwan() {
      return this.formData.province === '台灣'
    },
    cities() {
      return this.TaiwanCityMap.map(item => item.name)
    },
    districts() {
      const districts = this.TaiwanCityMap.find(item => item.name === this.formData.city)
      return districts ? districts.districts.map(item => item) : []
    }
  },
  watch: {
    dataSource: {
      deep: true,
      immediate: true,
      handler(value) {
        this.formData = {
          province: '台灣',
          city: '',
          district: '',
          postCode: '',
          address: '',
          receiverName: '',
          receiverTel: '',
          ...value
        }
      }
    },
    'formData.city': {
      deep: true,
      immediate: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          this.formData.district = this.districts[0] && this.districts[0].name
        }
      }
    },
    'formData.district': {
      deep: true,
      immediate: true,
      handler(value, oldValue) {
        if (value !== oldValue) {
          const district = this.districts.find(item => item.name === value)
          this.formData.postCode = district ? district.zip : ''
        }
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('onSubmit', this.formData)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
  @include minWidth992 {
    padding-right: 100px;
  }
}
::v-deep.el-dialog {
  border-radius: 32px;
  box-shadow: 0 2px 6px 0 $mainPurple;
  width: 90%;
  max-width: 500px;
}
.el-dialog__title {
  color: $mainPurple;
  font-size: 20px;
}
.el-dialog__body {
  height: calc(100% - 127px);
}

.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
    color: $mainPurple;
}

.el-dialog__close {
  font-size: 24px;
  font-weight: 600;
  &:hover {
    color: $mainPurple;
  }
}

.el-button--primary  {
  background-color: $mainPurple;
  border: 0;
  &:hover, &:focus {
    background-color: $mainPurple;
    opacity: 0.8;
  }
}
</style>
